import { jsx as _jsx } from "react/jsx-runtime";
import { RemoteVersionSelector } from './RemoteVersionSelector';
export function RemoteVersionSelectorRenderer(props) {
    var _ref;
    var _applicationRemotes_find;
    const { value, organization, project, application, appVersion, applicationRemotes, mutateApplication } = props;
    return /*#__PURE__*/ _jsx(RemoteVersionSelector, {
        organization: organization,
        project: project,
        application: application,
        appVersion: appVersion,
        remote: value,
        remoteVersion: (_ref = (_applicationRemotes_find = applicationRemotes.find((r)=>r.name === value)) === null || _applicationRemotes_find === void 0 ? void 0 : _applicationRemotes_find.version) !== null && _ref !== void 0 ? _ref : undefined,
        mutateApplication: mutateApplication
    });
}
